import axios from "axios";
import { BACKEND_URL } from "@/constants";
import { useAuth } from "@/stores/auth";
import { parsePydanticError } from "@/helpers/errors";
import { sanitizeBody } from "@/helpers/security";

export const api = axios.create({
  baseURL: BACKEND_URL,
});

api.interceptors.request.use(async (config) => {
  // Refresh token
  const auth = useAuth();
  auth.updateToken(70);

  const token = auth.keycloak?.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Sanitize body if needed
  if (config.data && !(config.data instanceof FormData)) {
    config.data = sanitizeBody(config.data);
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

// Handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response) {
      throw parsePydanticError(error.response.data);
    }
    throw error;
  },
);
